'use client';

import { useEffect } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import ServiceHeroSection from './components/ServiceHeroSection';
import PPFServiceSection from './components/PPFServiceSection';
import CeramicServiceSection from './components/CeramicServiceSection';
import TintingServiceSection from './components/TintingServiceSection';
import DetailingServiceSection from './components/DetailingServiceSection';
import ProcessSection from './components/ProcessSection';

export default function ServicesPage() {
  useEffect(() => {
    // Enable smooth scroll
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Handle hash navigation on page load
    if (window.location?.hash) {
      const hash = window.location?.hash?.substring(1);
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <>
      <Header />
      <main className="smooth-scroll">
        <ServiceHeroSection />
        <PPFServiceSection />
        <CeramicServiceSection />
        <TintingServiceSection />
        <DetailingServiceSection />
        <ProcessSection />
      </main>
      <Footer />
    </>
  );
}